import React, { useEffect, useState } from 'react';

interface StarProps {
  count?: number;
}

const StarField: React.FC<StarProps> = ({ count = 60 }) => {
  const [stars, setStars] = useState<{ 
    top: string; 
    left: string; 
    size: string; 
    twinkleDuration: string; 
    driftDuration: string;
    driftX: string;
    driftY: string;
    delay: string;
  }[]>([]);

  useEffect(() => {
    const generatedStars = Array.from({ length: count }).map(() => ({
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      size: `${Math.random() * 2 + 0.5}px`,
      twinkleDuration: `${Math.random() * 3 + 2}s`,
      driftDuration: `${Math.random() * 15 + 10}s`,
      driftX: `${(Math.random() - 0.5) * 100}px`,
      driftY: `${(Math.random() - 0.5) * 100}px`,
      delay: `${Math.random() * 5}s`,
    }));
    setStars(generatedStars);
  }, [count]);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {stars.map((star, i) => (
        <div
          key={i}
          className="star"
          style={{
            top: star.top,
            left: star.left,
            width: star.size,
            height: star.size,
            '--twinkle-duration': star.twinkleDuration,
            '--drift-duration': star.driftDuration,
            '--drift-x': star.driftX,
            '--drift-y': star.driftY,
            '--delay': star.delay,
          } as any}
        />
      ))}
    </div>
  );
};

export default StarField;